/* @flow strict */

import React from 'react';
import moment from 'moment';
import { currency } from '/client/src/constants/';
import _ from 'lodash';
import { format } from '/client/src/utils/amountTransformation';
import { EventDetailContainerContext } from '/client/src/contexts/EventDetailContainer';
import { convertToLocalTime } from '/client/src/utils/jstz';

export const columns = (): [] => {
  const context = React.useContext(EventDetailContainerContext);
  const time_zone_id = _.get(context, 'eventDetail.time_zone_id', '');

  return [
  {
    selector: 'customer_first_name',
    name: 'First Name',
    sortable: true
  },
  {
    selector: 'customer_last_name',
    name: 'Last Name',
    sortable: true
  },
  {
    selector: 'paid_time_utc',
    name: 'Date Purchased',
    sortable: true,
    cell: (row: {}): React.Element<'div'> => {
      return convertToLocalTime(_.get(row, 'paid_time_utc', ''), time_zone_id, 'MM/DD/YY h:mm a z')
    }
  },
  {
    selector: 'customer_email_address',
    name: 'Email',
    sortable: true
  },
  {
    selector: 'customer_phone_number',
    name: 'Phone',
    sortable: true
  },
  {
    selector: 'amount',
    name: 'Net Payments',
    sortable: true,
    cell: (row: {}): React.Fragment => {
      return (
        <>
          {  format(currency[_.get(row, 'currency', 'USD')], +row.amount, true)}
        </>
      );
    }
  }
];
};
